import React from 'react';
import '../Styles.scss';

export const Bodywork = () => {
    return (
        <>
            <h1 className="section__title">{'bodywork'}</h1>
            <div className="bodywork">
                <div className="bodywork__col-narrow">
                    <h2>Sensory Bodywork</h2>
                    <h3>for your</h3>
                    <h4>pussy, pleasure & power</h4>
                </div>
                <div className="bodywork__col">
                    <p>
                        Extend your capacity to experience pleasure and unlock
                        your full innate power through your pussy. What I do is
                        create a space for you to embark on a journey of
                        self-knowledge and self-discovery - because we can’t
                        have the first without the latter.
                    </p>
                    <p>
                        You'll reframe the perception of your body and therefore
                        your relationship with pleasure. This takes place in an
                        optimal environment where all of your senses are looked
                        after. Smell, vision, sound, touch and even taste.
                    </p>
                    <p>
                        I'm aware that touch is what raises more questions, so
                        what happens exactly in this sense? You’ll first
                        experience a subtle touch to awaken your whole body.
                        Then a massage to activate your pelvic area. And last
                        but not least, I will massage and stimulate your vulva
                        and vagina - if you're receptive to it.
                    </p>
                </div>
                <div className="bodywork__col">
                    <p>
                        This form of bodywork is the compilation of the
                        knowledge I gained on Sexological Bodywork, Tantric
                        Massage and Terapia Orgástica. I named what I do Sensory
                        Bodywork because this goes beyond sex or orgasms. And
                        also to refrain from this being associated with the
                        endless and unfortunate distortions of ancient sexual
                        knowledge. Unfortunately, there have been too many cases
                        of abuse and exploitation of vulnerable people under
                        those premises, even to the point of creating cults such
                        as the OneTaste Orgasmic Meditation.
                    </p>
                    <p>
                        This isn't to say that there aren't amazing
                        professionals following these practices. But many people
                        cannot afford them. So I offer this Sensory Bodywork on
                        a <span>Pay What You Can</span> basis, as all deserve
                        access to self-love and their own power.
                    </p>
                </div>
                <div className="bodywork__boxArea">
                    <div className="bodywork__col-grid-2">
                        <h2>
                            what's in it <br></br>for me?
                        </h2>
                        <p>
                            I always felt a deep level of empathy and only found
                            as an adult that I’m a highly sensitive person.
                            Maybe because of that, I’m very passionate about
                            helping others. This led me to a wide variety of
                            volunteering work - with animal shelters, elderly
                            care, organic farms and soup kitchens. I was also
                            the chair of the Women’s Network and the Corporate
                            Social Responsibility Committee during 5 years in my
                            latest job. And even though I see value in every
                            single experience I had, the most impactful way I
                            gave back to people, without doubt, is through this
                            Sensory Bodywork.
                        </p>
                        <p>
                            There is so much untouched potential in most of our
                            sexual relations, with partners and especially with
                            ourselves. I came for the first time at the age of
                            25. Before then, I went through phases of
                            questioning whether I was physically capable of
                            orgasm, to think that I had already even though it
                            didn’t match any description I’d seen. I’m offering
                            this experience because I know I wasn’t the only one
                            feeling this way. I do this because I fear that most
                            people have only glimpsed the transformative power
                            of being in touch with their bodies. And ultimately,
                            I do this because I know it’s hard to be invested in
                            pursuing something you’re yet to experience and
                            therefore is beyond your comprehension. I hope to
                            share a light into your consciousness and show you a
                            new possibility. The possibility to embrace more
                            independence, self-love, awareness, and spirituality
                            into your life.
                        </p>
                    </div>
                </div>
            </div>
            <div className="bodywork">
                <div>
                    <h2>what's in it for you?</h2>
                </div>
                <div className="bodywork__col-grid-2">
                    <section>
                        <h3>more independence</h3>
                        <p>
                            I believe the most fundamental human need is to feel
                            loved. And we are all taught, even if unwillingly,
                            the importance of pleasing others. Yet, only a few
                            of us learn how to please and love ourselves.
                            <span>
                                {' '}
                                Society does not teach us that self-love is the
                                only one that we truly need. And as long as we
                                depend on anyone’s love and acceptance besides
                                our own, we can’t be completely fulfilled.{' '}
                            </span>
                            I believe that learning how to please yourself is a
                            crucial step in reaching this level of independence,
                            which leads to a much happier and uncomplicated
                            life. And even though you’ll be receiving pleasure
                            from someone else in this bodywork, all I’ll be
                            doing is revealing your own natural potency.
                            Anything that you’ll experience has always been
                            within you. I’m just showing you the door, and then
                            it’s up to you to walk through it and integrate what
                            you've learned. It’ll always be within your reach.
                        </p>
                    </section>
                    <section>
                        <h3>more awareness</h3>
                        <p>
                            What we’ll do is to enhance your natural orgasmic
                            potency. Orgasmic potency is our capacity to
                            accumulate tension before releasing it in the form
                            of an orgasm. You can see it as a rollercoaster: the
                            higher the tension, the higher the release will be.
                            And when you achieve this greater level of release,
                            your brain reaches an altered state of consciousness
                            where wonderful experiences can happen.
                            <span>
                                {' '}
                                It has the power to magnify pleasure in all
                                aspects of your life - by unlocking a heightened
                                receptivity to all your five senses and all the
                                pleasures they provide. And you might find
                                yourself more creative or even seeing things
                                more clearly afterwards.{' '}
                            </span>
                            That’s the result of becoming more aware and in tune
                            with yourself, ultimately leading to a fuller life.
                            Libido is a form of vital energy, not limited to the
                            sexual realm alone.
                        </p>
                    </section>
                    <section>
                        <h3>more self-love</h3>
                        <p>
                            I learned to love myself completely once I started
                            to embrace my physical body as a vehicle, a vehicle
                            for both physical and emotional health. While the
                            importance of looking after our bodies for
                            well-being is well-known, there isn't enough light
                            on how an orgasm can be a powerful means to the same
                            end. We are finally seeing studies that prove its
                            health benefits. But beyond that,
                            <span>
                                {' '}
                                a truly profound orgasm teaches you to
                                appreciate your body for its potency rather than
                                its appearance. Independently of how we look,
                                our bodies are biologically designed to feel
                                pleasure.{' '}
                            </span>
                            Every single cell in our skin is a receptor. By
                            learning how to activate all of these cells and
                            having the foundation to process this experience,
                            you can achieve this profound and transformative
                            orgasm. And once you witness where your body can
                            take you, physically, emotionally and spiritually,
                            you naturally reach another level of self-love.
                        </p>
                    </section>
                    <section>
                        <h3>more spirituality</h3>
                        <p>
                            Orgasm in French is called 'La Petite Mort,' which
                            means 'little death.' I find this to be a very
                            accurate term to describe that moment when your ego
                            (and who you think you are) temporarily cease to
                            exist, and you just be. Existing purely in the
                            present, feeling completely fulfilled. A state that
                            can be achieved through meditation alone, but it
                            might take years of dedication to reach that. But
                            <span>
                                {' '}
                                people with vulvas are blessed with a 'divine
                                sacred portal' - the meaning of Yoni, the
                                Sanskrit word for the female sexual organs. So
                                in this sense, I like to see orgasm as a faster
                                and more accessible way to sneak peek into
                                enlightenment.{' '}
                            </span>
                            Independently of what spiritual work means to you, I
                            believe that it’s impossible not to feel connected
                            with something greater than yourself when you reach
                            these different planes of consciousness through
                            orgasm. And to see your body as the temple it truly
                            is.
                        </p>
                    </section>
                </div>
            </div>
            <div className="bodywork">
                <h2>testimonials</h2>
                <div className="bodywork__boxArea">
                    <aside>
                        I'd rather refrain from sharing personal testimonials as
                        it can create misleading expectations. So,{' '}
                        <span>
                            I advise to not read this section before your
                            session.
                        </span>{' '}
                        I only share it for people who need this to feel safe to
                        embark on this journey. If that's your case, please read
                        it bearing in mind that each body will have a unique
                        experience.
                    </aside>
                </div>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <div>
                    <br></br>
                    <h5>”</h5>
                    <blockquote>
                        It was pure expansion. And a cleanse. I felt so light
                        and so much love. Happy moments of my life kept popping
                        up in my mind. I accessed places that I didn't even
                        remember, and others that I didn't even know existed.
                        For a while, I completely forgot where I was. And I know
                        this didn’t make sense because I was sober, but
                        afterwards, I felt completely high
                    </blockquote>
                    <cite>— Bruna Christo</cite>
                </div>
                <br></br>
                <br></br>
                <div>
                    <h5>”</h5>
                    <blockquote>
                        Night of 1000 suns. I walk home and I feel high,and it's
                        not because of the boots. I feel fast, and it's not
                        because of the scooter, I feel calm and strong. This is
                        a therapy, which is also a massage, which is also a
                        ritual. During the process I went through several layers
                        of emotions, sensations and thoughts, from relaxation
                        after the initial embarrassment, goosebumps at the
                        touch, concern for my friend, fear of being frigid, of
                        not being able to, of disappointing. But then, I
                        breathed and the calmness and the feeling of being safe
                        returned. Until another thought came, and the breathing
                        returned again. As the music and the sensations took
                        over, the cycle of thoughts diminished, sometimes the
                        sensations were so strong that the emotions disappeared
                        and I no longer knew exactly where my body began and
                        ended. I reached my first orgasm, a light and familiar
                        feeling, which was followed by a, also familiar, greater
                        relaxation of the body. I took a deep breath again and I
                        thought instinctively that we had finished the session.
                        But no, the movement and the music continued and I had a
                        second orgasm, also this light one, but I already felt
                        more relaxed and unconcerned, and I remember thinking,
                        now that the session is over. It was already quite
                        surprising given that I think it was the first time I
                        had 2 orgasms. But as the music changed I realised that
                        it didn't stop there. I genuinely thought that my body
                        had already given everything it had to give, but after a
                        few minutes when the music and the sensations came
                        together, I forgot everything and had a third orgasm.
                        But it was as if it had been the first, not of the
                        session, but of my life almost. It was very different,
                        pleasurable for sure, but more than that it was
                        powerful, I felt as if I had caused a ball of light to
                        be born throughout my body, and I felt as if I had left
                        my body with that light. And then, I went back and burst
                        into tears. Not out of sadness, but I think just out of
                        emotion, or energy. Whatever it was, I felt that I
                        released something and that with, a slightly different
                        version of me was born, who knows herself better and
                        carries courage in her womb.
                    </blockquote>
                    <cite>— Joana Carvalinho</cite>
                </div>
                <br></br>
                <br></br>
                <div>
                    <h5>”</h5>
                    <blockquote>
                        You put me at ease more than I could have imagined and
                        made me feel comfortable in myself which really allowed
                        me to let go. I lost all sense of time with the eye mask
                        on and became completely absorbed in the physical
                        sensation. The pleasure that you gave me was, of course,
                        amazing, but my real appreciation comes from the fact
                        that it was such a selfless act on your part because it
                        was completely focused on me. This was a unique
                        experience because even doing a tantric massage with a
                        partner is in the context of a relationship where there
                        is reciprocation. So this act on your part of wanting to
                        devote your time, energy and emotion completely for my
                        pleasure was just magical. I loved sharing the
                        experience with you afterwards and seeing you cry with
                        me was so beautiful because your ability to feel such
                        compersion is so powerful. I am just so grateful to know
                        someone as special as you, and you are like no one else
                        I know in so many wonderful ways. I am forever in awe of
                        how you are expanding your mind and your experiences and
                        honoured that you want me and all your friends to share
                        in those experiences.
                    </blockquote>
                    <cite>— Ellie Wintram</cite>
                </div>
                <br></br>
                <br></br>
                <div>
                    <h5>”</h5>
                    <blockquote>
                        Thank you again for the most incredible experience
                        tonight ❤ As soon as I arrived I was totally immersed by
                        the music, lighting, set-up of the bed, perfect
                        temperature and scent of coconut - it was already
                        magical. The context at the start of the session was so
                        heartfelt and I was blown away by your words, I loved
                        hearing about why this is so important to you and it
                        made it even more special. The experience itself
                        exceeded all expectations - even though I tried to have
                        no expectations at all so that I could be completely
                        present, but after getting over my own insecurities that
                        arose at the beginning I felt so connected to you and
                        the respectful, considerate, loving experience that you
                        created. I'm completely floored by your selflessness and
                        the level of care and time you put into giving me such a
                        mind-blowing spiritual experience. I definitely do liken
                        it to the mushroom trip that you also selflessly guided
                        me through and I really can't thank you enough for both
                        experiences. I really felt like I went on a journey with
                        my body, from shame to acceptance, to completely
                        embracing pleasure and letting go of my ego. Thank you
                        for your care, time, effort, and love.
                    </blockquote>
                    <cite>— Heather B.</cite>
                </div>
            </div>
            <div className="bodywork">
                <h2>faq</h2>
                <div>
                    <h3>What happens exactly?</h3>
                    <p>
                        This Sensory Bodywork takes place in an optimal
                        environment where all of your senses are looked after.
                        I'll explain during the session how smell, vision, sound
                        and taste will be stimulated. I'm aware though that
                        touch is what raises more questions, so here is what
                        happens in this sense: you’ll first experience a subtle
                        touch to awaken your whole body. Then a massage to
                        activate your pelvic area. Last but not least, I will
                        massage and stimulate your vulva (the external parts of
                        a woman's genitalia) and if you’re receptive to this, I
                        can also stimulate your vagina (the internal part). For
                        this reason, you’ll be fully naked. You’ll be in full
                        control of the situation. Your consent can be withdrawn
                        at any time and I’ll cease to touch you as soon as you
                        tell me so.
                    </p>
                    <h3>Who can receive it?</h3>
                    <p>
                        I offer this Sensory Bodywork to anyone that has a vulva
                        (not limited to cisgender). I'd love to extend it to
                        women with a penis, but currently, my level of knowledge
                        for this genitalia is not enough as most of my learnings
                        have been focused on vulvas. As for men, I understand
                        they also need healing from all the toxic masculinity
                        and pressure that society has imposed on them. But as
                        long as the striking{' '}
                        <a
                            href="https://www.instagram.com/p/Cg_fHVgNl45/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            orgasm gap
                        </a>{' '}
                        is a reality, I’ll not offer this to men.
                    </p>
                    <h3>When can it happen?</h3>
                    <p>
                        The Sensory Bodywork takes place at night and it’s not
                        advisable that you plan anything afterwards, aside from
                        time to integrate and rest. You must send me an
                        Instagram direct message (or email) so we can schedule a
                        session. Please note that the waiting list can be from
                        weeks to months. It’s the most rewarding work I have
                        ever done, but it’s also very draining for me -
                        emotionally, physically and spiritually. And this is not
                        my job, I only do it to empower others, not to make
                        money. So because of that, I have a very limited amount
                        of time available.
                    </p>

                    <h3>Where does it take place?</h3>
                    <p>
                        Although I understand that some people would rather have
                        this in the comfort of their homes, I cannot guarantee
                        to deliver the same level of experience in different and
                        unknown spaces. The Sensory Bodywork takes place in an
                        optimal environment where all of your senses are looked
                        after. The location is in East London. For security
                        reasons, I only share the exact address after we have an
                        initial conversation so we can both feel safe embarking
                        on this experience together.
                    </p>
                    <h3>Why would I want this?</h3>
                    <p>
                        To extend your capacity to experience pleasure and
                        unlock your full innate power through your pussy. To
                        enhance your natural orgasmic potency. To reframe the
                        perception of your body and therefore your relationship
                        with pleasure. To embrace more independence, self-love,
                        awareness, and spirituality into your life.
                    </p>
                    <h3>How long does it last?</h3>
                    <p>
                        A Sensory Bodywork session takes between 2,5h to 3h.
                        During the first 30-60min, I'll share key learnings to
                        help you connect with the experience and beyond, explain
                        everything that will happen and give you the space to
                        express your needs and expectations. Then there will be
                        a 90min full-body massage, followed by 30min for
                        integration - when you'll be able to process this
                        experience on your time, aside from taking a shower if
                        you wish.
                    </p>
                    <h3>How much does it cost?</h3>
                    <p>
                        I believe all deserve access to self-love and their own
                        power, so I offer this Sensory Bodywork on a Pay What
                        You Can basis. But as long as I cannot sustain myself
                        with this, my availability will be quite limited. So for
                        people who can and wish to support me financially,
                        contributions will allow me to allocate more time for
                        this work - and help others who cannot afford it.
                        Similar bodywork in London costs from £240 upwards, but
                        I accept and appreciate any amount you can contribute
                        with.
                    </p>
                    <h3>How to prepare for it?</h3>
                    <p>
                        It’s advisable that you don’t consume alcohol or any
                        drugs before this Sensory Bodywork so you can be fully
                        present. Fasting is not advisable unless you’re used to
                        it - you don’t want to get distracted by hunger mid-way
                        through. You should eat in the same way you would before
                        doing an exercise.
                    </p>
                    <h3>
                        Are people who experienced sexual trauma or abuse
                        suitable for this?
                    </h3>
                    <p>
                        This Sensory Bodywork can be extremely healing for
                        people who experienced sexual trauma and abuse. However,
                        if this is your case, I don’t advise doing it without a
                        professional therapist to support you afterwards. To
                        treat wounds, they need to be brought to the surface.
                        And this Sensory Bodywork has the power to unlock
                        profound and deeply blocked memories. I’m a certified
                        Mental Health First Aider, so I’ll be equipped to
                        support you during the session. But afterwards, you
                        might need to be accompanied by therapy to be able to
                        process and integrate everything you experienced.
                    </p>
                </div>
                <br></br> <br></br>
            </div>
        </>
    );
};
